import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=webp&auto=format,compress&w=1600&q=80";

export default function CareersHero() {
  return (
    <section
      id="top"
      data-testid="careers-hero"
      className="relative pt-24 md:pt-28"
    >
      <div className="mx-auto max-w-[1440px] w-full px-6 md:px-10 pb-6 md:pb-8">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex items-center gap-4"
        >
          <span className="mono-label">[00] — Careers · Pune, India</span>
          <span className="h-px flex-1 bg-white/10" />
          <span className="mono-label hidden md:inline">beaconitdev.com/careers</span>
        </motion.div>
      </div>

      <div className="relative w-full">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, ease: [0.7, 0, 0.2, 1] }}
          className="relative w-full h-[64svh] md:h-[72svh] min-h-[480px] overflow-hidden bg-[#0b0e18] grain"
        >
          <img
            src={HERO_IMG}
            alt="Beacon IT Dev engineering team collaborating"
            className="absolute inset-0 w-full h-full object-cover opacity-80"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#080A0F] via-[#080A0F]/70 to-[#080A0F]/30" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#080A0F] via-transparent to-[#080A0F]/50" />
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0"
            style={{
              background:
                "radial-gradient(45% 55% at 22% 55%, rgba(255,59,48,0.10), transparent 70%)",
            }}
          />

          <div className="absolute left-6 md:left-10 top-5 mono-label !text-white/70">
            JOIN · 2026
          </div>
          <div className="absolute right-6 md:right-10 top-5 mono-label !text-white/60">
            5 OPEN ROLES — <span className="text-[color:var(--accent)]">HIRING</span>
          </div>

          <div className="relative z-10 mx-auto max-w-[1440px] w-full h-full px-6 md:px-10 flex items-center">
            <div className="max-w-[760px]">
              <motion.h1
                data-testid="careers-heading"
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, delay: 0.15, ease: [0.7, 0, 0.2, 1] }}
                className="font-display text-[34px] sm:text-[44px] md:text-[58px] lg:text-[68px] leading-[1.02] tracking-[-0.03em]"
              >
                Build your career with{" "}
                <br />
                <span className="text-[color:var(--accent)]">Beacon IT Solutions</span>
                <span className="text-[color:var(--accent)]">.</span>
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.45 }}
                className="mt-6 md:mt-8 max-w-[520px] text-white/70 text-[14px] md:text-[16px] leading-[1.6]"
              >
                Join a team of developers, engineers, designers and technology professionals
                building innovative digital solutions for businesses around the world.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                className="mt-8 flex flex-wrap items-center gap-3 md:gap-4"
              >
                <a
                  href="#openings"
                  data-testid="careers-hero-cta"
                  className="group inline-flex items-center gap-3 bg-[color:var(--accent)] hover:bg-[color:var(--accent-hover)] px-5 md:px-6 py-3.5 md:py-4 text-[13px] md:text-[14px] font-medium tracking-tight"
                >
                  View open positions
                  <ArrowDown size={16} className="transition-transform group-hover:translate-y-0.5" />
                </a>
                <a
                  href="#apply"
                  className="inline-flex items-center gap-3 border border-white/25 hover:border-white/70 bg-black/20 backdrop-blur-sm px-5 md:px-6 py-3.5 md:py-4 text-[13px] md:text-[14px] tracking-tight transition-colors"
                >
                  Send your resume
                </a>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.9, duration: 0.6 }}
        className="mx-auto max-w-[1440px] w-full px-6 md:px-10 mt-6 md:mt-8 flex items-center gap-4"
      >
        <span className="mono-label">Scroll</span>
        <span className="h-px flex-1 bg-white/10" />
        <span className="mono-label">PHP · Node · React · UI · QA</span>
      </motion.div>
    </section>
  );
}
